<template>
  <div class="d-flex flex-column justify-center align-center mx-auto" style="width: 400px; min-height: 320px">
    <v-img max-width="100px" max-height="100px" contain src="@/assets/upload-file.svg" />
    <div class="text-center content-text mt-5">Tải lên tệp Excel (.xlsx) chứa điểm của học sinh</div>
    <div class="mt-5 d-flex align-center">
      <!-- <v-btn outlined color="primary" class="mr-6">Tải file mẫu</v-btn> -->
      <v-btn color="primary" class="elevation-0" :loading="isSelecting" @click="onExcelUpload">
        <span>Chọn tệp</span>
        <input
          ref="uploader"
          type="file"
          class="d-none"
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          @change="onFileChanged"
        />
      </v-btn>
    </div>
  </div>
</template>
<script>
import Excel from 'exceljs'
import unidecode from 'unidecode'
import { mapActions, mapState } from 'vuex'

const ROW_HEADER_INDEX = 5

export default {
  props: { isMarkTypeNumber: { type: Boolean, default: true } },
  data: () => ({ isSelecting: false }),
  computed: {
    ...mapState('ClassMarkInput', ['isClassExtraCurriculum']),
    factorCellIndexStart() {
      if (this.isClassExtraCurriculum) return 6
      return 5
    }
  },
  methods: {
    ...mapActions({
      saveExcelImportPreview: 'ClassMarkInput/saveExcelImportPreview'
    }),
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    onExcelUpload() {
      this.isSelecting = true
      window.addEventListener(
        'focus',
        () => {
          this.isSelecting = false
        },
        { once: true }
      )

      this.$refs.uploader.click()
    },
    getFactorHeaders({ rowHeader = {} }) {
      const res = []

      const { cellCount } = rowHeader
      let startIndex = this.factorCellIndexStart
      while (startIndex <= cellCount) {
        const cell = rowHeader.getCell(startIndex)
        if (cell.isMerged) {
          const mergeCount = cell._mergeCount
          res.push({ title: cell.value, maxCol: mergeCount + 1 })
          startIndex += mergeCount + 1
        } else {
          res.push({ title: cell.value, maxCol: 1 })
          startIndex += 1
        }
      }
      return res
    },
    getRowMarks({ row = {}, limit = 0, start = 0 }) {
      const res = []

      let startIndex = start
      while (startIndex < limit) {
        res.push(row.getCell(startIndex).value)
        startIndex++
      }

      return res
    },
    validateMarkType(marks = []) {
      const filteredMarks = marks.filter(Boolean)
      if (!this.isMarkTypeNumber) {
        const allowedSymbols = ['d', 'kd']
        return filteredMarks.some(m => !allowedSymbols.includes(unidecode(`${m}`.toLowerCase())))
      }
      return filteredMarks.some(m => isNaN(Number(m)))
    },
    bulkValidate(marks1 = [], marks2 = [], marks3 = []) {
      const isValid1 = this.validateMarkType(marks1)
      const isValid2 = this.validateMarkType(marks2)
      const isValid3 = this.validateMarkType(marks3)
      return isValid1 || isValid2 || isValid3
    },
    async getImportData(file) {
      const workbook = new Excel.Workbook()
      await workbook.xlsx.load(file)
      const ws = workbook.getWorksheet('Marks')
      const rowHeader = ws.findRow(ROW_HEADER_INDEX)

      const factors = this.getFactorHeaders({ rowHeader })
      const data = []
      const errors = []

      for (let i = ROW_HEADER_INDEX + 1; i <= ws.rowCount; i++) {
        const row = ws.findRow(i)
        if (!row) continue

        const factor1IndexStart = this.factorCellIndexStart
        const factor1IndexEnd = this.factorCellIndexStart + factors[0].maxCol
        const factor2IndexEnd = factor1IndexEnd + factors[1].maxCol
        const tmp_1 = this.getRowMarks({ row, start: factor1IndexStart, limit: factor1IndexEnd })
        const tmp_2 = this.getRowMarks({ row, start: factor1IndexEnd, limit: factor2IndexEnd })
        const tmp_3 = this.getRowMarks({ row, start: factor2IndexEnd, limit: factor2IndexEnd + 1 })

        const isInvalid = this.bulkValidate(tmp_1, tmp_2, tmp_3)
        if (isInvalid) errors.push(i)

        const params = {
          index: row.getCell(1).value,
          code: row.getCell(2).value,
          name: row.getCell(3).value,
          dob: row.getCell(4).value,
          marks_1: Array.from(Array(factors[0].maxCol).keys()).map(index => tmp_1[index] || ''),
          marks_2: Array.from(Array(factors[1].maxCol).keys()).map(index => tmp_2[index] || ''),
          marks_3: Array.from(Array(factors[2].maxCol).keys()).map(index => tmp_3[index] || '')
        }
        if (this.isClassExtraCurriculum) params['classTitle'] = row.getCell(5).value
        data.push(params)
      }

      if (errors.length) return errors

      this.saveExcelImportPreview({ excelFactors: factors, excelData: data, excelFileName: file.name })
    },

    async onFileChanged(e) {
      this.$loading.active = true
      const errors = await this.getImportData(e.target.files[0])
      this.$emit('on-file-change', errors)
    }
  }
}
</script>
